import { Message } from 'semantic-ui-react';
import { get } from '../utils/lodash';
import { withTranslation } from 'react-i18next';
import './styles.scss';

const EvalPlanDisableComponent = ({ t, ...props }) => (
  <div className="locked-activity">
    <Message negative>
      <Message.Header>
        {get(props, 'haveResponses', false)
          ? t('activity.evaluation.evaluation_closed')
          : t('activity.evaluation.disabled')}
      </Message.Header>
      <p>
        {get(props, 'haveResponses', false)
          ? t('activity.evaluation.closed_message')
          : t('activity.evaluation.disabled_message')}
      </p>
      <p>
        {get(props, 'disabledReason', null)
          ? `${t('activity.evaluation.reason')}: ${get(props, 'disabledReason', null)}`
          : ''}
      </p>
    </Message>
  </div>
);

export const EvalPlanDisable = withTranslation()(EvalPlanDisableComponent);
export default EvalPlanDisable;
